<template>
    <div id='assignments-chart'></div>
</template>

<script>
    import c3 from 'c3'
    import d3 from 'd3'
    var chart = {};

    export default {
        replace: true,
        data: function() {
            return {}
        },
        props: ['data'],
        watch: {
            'data': function(val) {
                this.chart.load({columns: val}); 
            }
        },
        mounted: function() {

            const el = this.$el;

            var that = this;

            this.chart = c3.generate({
                size: {
                    height: 200
                },
                legend: {
                    position: 'right'
                },
                tooltip: {
                    format: {
                        value: function (value, ratio, id) {
                        return value + ' hrs';
                        }
                    }
                },
                 data: {
                    columns: this.data,
                    type: 'bar',
                },
                 axis: {
                    x: {
                        type: 'category',
                        categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri']
                    },
                    y: {
                        max: 8
                    }
                },
                 grid: {
                    y: {
                        lines: [
                            {value: 7, text: '7 Hours', position: 'start'},
                        ]
                    }
                },
                bar: {
                    width: {
                        ratio: 0.5 // this makes bar width 50% of length between ticks
                    }
                    // or
                    //width: 100 // this makes bar width 100px
                },
                bindto: "#assignments-chart"
            });
        }
    }
</script>
